<template>
  <div>
    <transition name="a-fade">
      <div v-show="overlayStore.loader" class="c-loader-overlay fixed left-0 top-0 flex items-center justify-center w-full h-full text-5xl font-semibold bg-white bg-opacity-75">
        <AtomIconAppLoader class="w-16 h-16 text-app-green md:w-48 md:h-48" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { useOverlayStore } from '~/store/overlay'

const overlayStore = useOverlayStore()
</script>

<style lang="scss" scoped>
.c-loader-overlay {
  z-index: 51; // needs to be higher than TailwindCSS highest number which is 50
}

.a-fade-enter-active,
.a-fade-leave-active {
  @apply transition duration-150 transition-opacity ease-in-out;
}

.a-fade-enter,
.a-fade-leave-to {
  @apply opacity-0;
}
</style>
